import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import { Client, ProductGroup } from '@app/core/models/client';
import { CharacterLimits } from '@app/core/utils/characterLimits';
import { ErrorDisplayComponent } from '@app/shared/error-display/error-display.component';
import { FormInputStateControlComponent } from '@app/shared/form-input-state-control/form-input-state-control.component';
import { TinyEditorComponent } from '@app/shared/tiny-editor/tiny-editor.component';
import { SafeHtmlPipePipe } from '@app/shared/pipes/safe-html.pipe';

@Component({
  selector: 'rn-sign-up-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorDisplayComponent,
    FormInputStateControlComponent,
    TinyEditorComponent,
    SafeHtmlPipePipe,
  ],
  templateUrl: './sign-up-form.component.html',
  styleUrl: './sign-up-form.component.scss',
})
export class SignUpFormComponent implements OnInit, OnChanges {
  @Input() client: Client;

  @Input() productGroup: ProductGroup;
  @Input() express_written_consent_ts_cs: string;
  @Input({ required: true }) signUpGroup: UntypedFormGroup;

  ngOnInit() {
    this.initializeExpressWrittenConsentControl();
    this.updateExpressWrittenConsentValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['express_written_consent_ts_cs']) {
      this.updateExpressWrittenConsentValue();
    }
  }

  private initializeExpressWrittenConsentControl() {
    if (!this.signUpGroup.contains('expressWrittenConsent')) {
      this.signUpGroup.addControl('expressWrittenConsent', new FormControl('', [Validators.required]));
    }
  }

  private updateExpressWrittenConsentValue() {
    const control = this.signUpGroup.get('expressWrittenConsent');
    if (control) {
      const value = this.express_written_consent_ts_cs || '';
      control.setValue(value);
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }

  getCharacterLimit(form: string) {
    switch (form) {
      case 'signUpSuccessCopy':
        return CharacterLimits.SignUpPageSuccessCopy;
      case 'signUpFailureCopy':
        return CharacterLimits.SignUpPageFailureCopy;
      case 'signUpPageSubmitButtonLabel':
        return CharacterLimits.SignUpPageSubmitButtonLabel;
      case 'signUpPageTermsAndConditions':
        return CharacterLimits.SignUpPageTermsAndConditions;
      case 'signUpPageTermsAndConditionsValidationError':
        return CharacterLimits.SignUpPageTermsAndConditionsValidationError;
    }
  }
}
